import Vue from 'vue';
import { IconPack, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import {
    faBranch,
    faLayout,
    faLayoutsGroup,
    faRemoveLayout,
    faUngroup,
    faPerspective,
    faSelection,
    faCanvas,
    faArrowsUpDownToLine
} from '@awesome.me/kit-4c37f718d5/icons/kit/custom';

library.add(fas as IconPack);
library.add(fab as IconPack);
library.add(far as IconPack);
library.add(
    faLayout,
    faLayoutsGroup,
    faRemoveLayout,
    faBranch,
    faUngroup,
    faPerspective,
    faSelection,
    faCanvas,
    faArrowsUpDownToLine
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
